import { lang } from '../../assets/lang'
import { delayHtml } from '../../data/modal/delayHtml'

export const videoHtml =
'<div id="file-upload-media-url-group" class="form-group text-left mt-2">' + 
  '<label for="file-upload-media-url">' + lang.video_html_label_video_url + '</label>' +
  '<input type="text" class="form-control" id="file-upload-media-url" placeholder="' + lang.video_html_placeholder_video_url+ '">' +
'</div>' +

'<div class="form-group fb-file-upload mt-4">' +
  '<div id="file-upload-dropzone" class="dropzone d-flex justify-content-center align-items-center mb-1">' +
    '<div class="dz-default dz-message">' +
      '<input type="file" class="d-none" name="uploaded-file-video" id="uploaded-file-video">' +
      '<i class="fas fa-cloud-upload-alt"></i>' +
    '</div>' +
  '</div>' +
  '<span class="text-small text-muted">' + lang.video_html_info_supported_media + '</span>' +
'</div>' +

// Adds html for delay system
delayHtml